import * as React from 'react';
import { connect } from 'react-redux';
import KeywordController from '../../Forms/Keywords/controller/KeywordsController';
import { IWorkflowItemStep } from '../../../common/sharedTypes';
import { loadImage } from './redux-objects/actions';
import { UserInfo } from '../../Login/common/defaults';

export interface IKeywordActionProps {
  loadImage?: (documentId: string, forceNewWindow: boolean) => Promise<void>;
}

interface IKeywordStateProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
  currentImageWindow: any;
}

interface IKeywordProps extends IKeywordActionProps, IKeywordStateProps { }

const initialState = {
  imagePopupExists: false,
};

type IKeywordState = Readonly<typeof initialState>;

class Keyword extends React.Component<IKeywordProps, IKeywordState> {
  public constructor(props: IKeywordProps) {
    super(props);
    this.state = initialState;
  }

  getDocumentId = (): string | null => {
    const report = this.props.openWorkflowItemStep?.workflowItem?.report;
    return (
      report?.paperReport?.documentId ||
      report?.documentId ||
      report?.keywords?.documentId ||
      null
    );
  };

  componentDidMount() {
    if (!this.props.openWorkflowItemStep) {
      this.props.history.push('/KeywordQueue');
    } else {
      const documentId = this.getDocumentId();
      if (documentId) {
        this.loadImage(false);
      } else {
        //console.log('no documentId?', this.props.openWorkflowItemStep);
      }
    }
  }

  loadImage = (forceNewWindow: boolean) => {
    const documentId = this.getDocumentId();
    if (!documentId) {
      return;
    }

    this.props.loadImage(documentId, forceNewWindow);
  };

  openPaperReport = (event: React.MouseEvent<HTMLElement>) => {
    this.loadImage(true);
  };

  handleHasSaved = (assignNext: boolean) => {
    if (assignNext) console.log('stayingput');
    else this.props.history.push('/KeywordQueue');
  };

  public render() {
    return (
      <div>
        {this.props.openWorkflowItemStep && (
          <KeywordController
            keywordData={
              this.props.openWorkflowItemStep?.workflowItem?.report?.keywords
            }
            hasSaved={this.handleHasSaved}
            openPaperReport={this.openPaperReport}
          />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    openWorkflowItemStep: state.Keywords.openWorkflowItemStep,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
    currentImageWindow: state.Keywords.currentImageWindow,
  };
}

const mapDispatchToProps = {
  loadImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Keyword);
